module.exports = __webpack_public_path__ + "img/s-19.6f5160fc.jpg";